/**
 * Widget turlari. Yangi widget: `features/widgets/<tur>/` papkasi (WidgetDef), shu ro'yxatga bitta qator, backend'da
 * `apps/widgets/registry.py` ga tur va sozlama tekshiruvi, tarjimalar -- widgets namespace.
 */
import { calendarWidget } from "./calendar";
import { callNowWidget } from "./callnow";
import { clockWidget } from "./clock";
import { feesWidget } from "./fees";
import { goalWidget } from "./goal";
import { noteWidget } from "./note";
import { rateWidget } from "./rate";
import { recentWidget } from "./recent";
import { shiftWidget } from "./shift";
import { startsWidget } from "./starts";
import type { WidgetDef } from "./types";

export const WIDGET_LIST = [clockWidget, calendarWidget, callNowWidget, shiftWidget, goalWidget, startsWidget, feesWidget, noteWidget, recentWidget, rateWidget] as unknown as WidgetDef[];
export const WIDGETS: Record<string, WidgetDef> = Object.fromEntries(WIDGET_LIST.map((d) => [d.type, d]));
